// Integrator server: driver manifests + connection test.
//
// A driver manifest declares everything the manager needs to render an integration's
// setup — connection keys (secret/optional), jobs with their roles and settings, value
// families. Served by DLIntegratorServer's GET /integrator/drivers; see
// docs/INTEGRATION_SETUP_DESIGN.md there.

interface WebService
{
    integratorDrivers( completion:any ) : void;
    testIntegrator( integrator:Integrator, completion:any ) : void;
    integratorMatrixGrid( mappingInfo:IntegratorMappingInfo, completion:any ) : void;
    setupIntegratorJobs( integrator:Integrator, completion:any ) : void;
    integratorHealth( integrator:Integrator, completion:any ) : void;
    integratorsHealth( completion:any ) : void;
    integratorHistory( integrator:Integrator, completion:any ) : void;
    retryIntegratorSync( syncID:string, completion:any ) : void;
}

WebService.prototype.integratorDrivers = function( completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/integrator/drivers";
    let r = new DLRequest ( url_str, null, "GET" );
    r.execute( (json:any, error:any) => {
        completion( json != null ? (json["drivers"] ?? []) : [], error );
    } );
}

// The driver's connection test. Never posts anything to the external system; the server
// answers { ok, detail | error } with errors as payload, so the result always renders.
WebService.prototype.testIntegrator = function( integrator:Integrator, completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/integrator/test/" + integrator.identifier;
    let r = new DLRequest ( url_str, null, "POST" );
    r.execute( (json:any, error:any) => {
        completion( json, error );
    } );
}

// The mapping matrix rendered as the translation grid: one group per revenue center,
// categories as rows, each cell carrying its code and what backs it (rule id, legacy
// cell, or empty). Generic — one shape for every integration.
WebService.prototype.integratorMatrixGrid = function( mappingInfo:IntegratorMappingInfo, completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/integrator/matrix/grid/" + mappingInfo.identifier;
    let r = new DLRequest ( url_str, null, "GET" );
    r.execute( (json:any, error:any) => {
        completion( json, error );
    } );
}

// Creates the integrator's missing standard jobs from its driver's manifest.
WebService.prototype.setupIntegratorJobs = function( integrator:Integrator, completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/integrator/jobs/setup/" + integrator.identifier;
    let r = new DLRequest ( url_str, null, "POST" );
    r.execute( (json:any, error:any) => {
        completion( json, error );
    } );
}

// The verification surface: health ("is the setup complete?" — no external calls),
// history ("what actually happened?") and retry (the deliberate human action after a
// failure is fixed).
WebService.prototype.integratorHealth = function( integrator:Integrator, completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/integrator/health/" + integrator.identifier;
    let r = new DLRequest ( url_str, null, "GET" );
    r.execute( (json:any, error:any) => {
        let list = json != null ? (json["integrators"] ?? []) : [];
        completion( list.length > 0 ? list[0] : null, error );
    } );
}

WebService.prototype.integratorsHealth = function( completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/integrator/health";
    let r = new DLRequest ( url_str, null, "GET" );
    r.execute( (json:any, error:any) => {
        completion( json != null ? (json["integrators"] ?? []) : [], error );
    } );
}

WebService.prototype.integratorHistory = function( integrator:Integrator, completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/integrator/history/" + integrator.identifier;
    let r = new DLRequest ( url_str, null, "GET" );
    r.execute( (json:any, error:any) => {
        completion( json != null ? (json["syncs"] ?? []) : [], error );
    } );
}

WebService.prototype.retryIntegratorSync = function( syncID:string, completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/integrator/sync/retry/" + syncID;
    let r = new DLRequest ( url_str, null, "POST" );
    r.execute( (json:any, error:any) => {
        completion( json, error );
    } );
}
